export enum ScopeEnum {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL'
}
